module.exports = __webpack_public_path__ + "img/bodyParts.dd768e38.svg";